import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Caption: {
    id: 'label_caption',
    defaultMessage: 'Caption',
  },
  FocusPoint: {
    id: 'label_image_focus_point',
    defaultMessage: 'Focus point',
  },
  Format: {
    id: 'label_format',
    defaultMessage: 'Format',
  },
  Image: {
    id: 'label_image',
    defaultMessage: 'Image',
  },
  ImageAltText: {
    id: 'label_image_alt_text',
    defaultMessage: 'Image alternative text',
  },
  ImageTitle: {
    id: 'label_image_title',
    defaultMessage: 'Image title',
  },
  Type: {
    id: 'label_type',
    defaultMessage: 'Type',
  },
  Video: {
    id: 'label_video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'label_video_url',
    defaultMessage: 'Video URL',
  },
  VideoURLHelp: {
    id: 'help_video_url',
    defaultMessage: 'A link to a video (e.g. YouTube, Vimeo, etc.)',
  },
  Media: {
    id: 'label_media',
    defaultMessage: 'Media',
  },
  Autoplay: {
    id: 'label_autoplay',
    defaultMessage: 'Autoplay',
  },
  HideControls: {
    id: 'label_hide_controls',
    defaultMessage: 'Hide video controls',
  },
  ForceCaptions: {
    id: 'label_force_captions',
    defaultMessage: 'Always show captions',
  },
});

export const MediaSchema = (props) => ({
  addMessage: props.intl.formatMessage(messages.AddItem),
  conditions: {
    focus_point: {
      media_type: 'image',
    },
    image: {
      media_type: 'image',
    },
    image_alt_text: {
      media_type: 'image',
    },
    video: {
      media_type: 'video',
    },
    video_url: {
      media_type: 'external_video',
    },
    autoplay: {
      media_type: ['video', 'external_video'],
    },
    hide_controls: {
      media_type: ['video', 'external_video'],
    },
    force_captions: {
      media_type: ['video', 'external_video'],
    },
  },
  fieldsets: [
    {
      fields: [
        'media_type',
        'image',
        'video',
        'video_url',
        'image_alt_text',
        'image_title',
        'focus_point',
        'format',
        'caption',
        'autoplay',
        'hide_controls',
        'force_captions',
      ],
      id: 'default',
      title: '',
    },
  ],
  properties: {
    caption: {
      title: props.intl.formatMessage(messages.Caption),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    focus_point: {
      title: props.intl.formatMessage(messages.FocusPoint),
      widgetOptions: {
        frontendOptions: {
          widget: 'focus_point_widget',
          widgetProps: {
            vocabulary: {
              '@id': '/@vocabularies/fhnw.vocabularies.image_cropping_options',
            },
          },
        },
      },
    },
    format: {
      title: props.intl.formatMessage(messages.Format),
      default: 'none',
      widgetOptions: {
        frontendOptions: {
          widget: 'format_widget',
          widgetProps: {
            vocabulary: {
              '@id': '/@vocabularies/fhnw.vocabularies.media_format',
            },
          },
        },
      },
    },
    image: {
      title: props.intl.formatMessage(messages.Image),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            mode: 'single',
            return: 'single',
            selectableTypes: ['Image'],
          },
        },
      },
    },
    image_alt_text: {
      title: props.intl.formatMessage(messages.ImageAltText),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    image_title: {
      title: props.intl.formatMessage(messages.ImageTitle),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    media_type: {
      title: props.intl.formatMessage(messages.Type),
      default: 'image',
      widgetOptions: {
        frontendOptions: {
          widget: 'select',
          widgetProps: {
            vocabulary: {
              '@id': '/@vocabularies/fhnw.vocabularies.media_type',
            },
          },
        },
      },
    },
    video: {
      title: props.intl.formatMessage(messages.Video),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            mode: 'single',
            return: 'single',
            selectableTypes: ['File'],
          },
        },
      },
    },
    video_url: {
      description: props.intl.formatMessage(messages.VideoURLHelp),
      title: props.intl.formatMessage(messages.VideoURL),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    autoplay: {
      title: props.intl.formatMessage(messages.Autoplay),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    hide_controls: {
      title: props.intl.formatMessage(messages.HideControls),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    force_captions: {
      title: props.intl.formatMessage(messages.ForceCaptions),
      type: 'boolean',
    },
  },
  required: ['media_type'],
  title: props.intl.formatMessage(messages.Media),
});
